import React, { useState } from 'react';
import { Route, Switch, Redirect, useHistory, useLocation } from 'react-router-dom';

import { PRIVATE_PATH } from '../../../constants';
import SidebarWrapper from '../../../sections/SidebarWrapper';

import AgencyProfessionalsCredentials from '../agency-professionals-credentials/AgencyProfessionalsCredentials';
import AgencyProfessionalsCreateEmployeeContactInfo from './AgencyProfessionalsCreateEmployeeContactInfo';
import AgencyProfessionalsEditEmployee from './AgencyProfessionalsEditEmployee';
import { PencilIcon } from '../../../components/icons';

const AgencyProfessionalsCreate = () => {
	const [editMode, setEditMode] = useState(false);
	const [showEditIcon, setShowEditIcon] = useState(false);
	const location = useLocation();
	const history = useHistory();

	const sidebarItems = [
		{
			label: 'Employee Details',
			editTitle: 'Add Professional',
			isEditing: true,
			path: location.pathname,
			additionalAction: showEditIcon && !editMode && (
				<button className="edit-contact" onClick={() => setEditMode(true)} type="button">
					<PencilIcon />
					Edit
				</button>
			),
			editText: 'Add Professional',
			className: 'details-header'
		},
		{
			label: 'Credentials',
			// eslint-disable-next-line camelcase
			editTitle: `Credentials`,
			isEditing: true,
			path: null,
			className: 'credentials-header',
			isDisabled: true
		}
	];

	const handleBackToProfessionalsList = () => {
		history.push(PRIVATE_PATH.PROFESSIONALS_PAGE);
	};

	const handleCancel = () => {
		history.replace(`${PRIVATE_PATH.PROFESSIONALS_PAGE}/create`);
	};

	const handleNavigateToNextStep = (state) => {
		const values = {
			data: {
				email: state.data.email,
				phone: state.data.phone_number
			},
			notification: state.notification
		};
		history.push(`${PRIVATE_PATH.PROFESSIONALS_PAGE}/create/contact-information`, values);
	};

	return (
		<SidebarWrapper
			sidebarTitle="Manage Professional"
			sidebarItems={sidebarItems}
			backTitle="Back To Professionals"
			backAction={handleBackToProfessionalsList}
		>
			<Switch>
				<Route exact path={`${PRIVATE_PATH.PROFESSIONALS_PAGE}/create`}>
					<AgencyProfessionalsCreateEmployeeContactInfo handleNavigateToNextStep={handleNavigateToNextStep} />
				</Route>
				<Route
					exact
					path={`${PRIVATE_PATH.PROFESSIONALS_PAGE}/create/contact-information`}
					render={(props) =>
						props.location.state ? (
							<AgencyProfessionalsEditEmployee
								setEditMode={handleCancel}
								setShowEditIcon={setShowEditIcon}
								isCreating
							/>
						) : (
							<Redirect to={`${PRIVATE_PATH.PROFESSIONALS_PAGE}/create`} />
						)
					}
				/>
				<Route path={null}>
					<AgencyProfessionalsCredentials caregiverId={null} />
				</Route>
				<Route path="/*" render={() => <Redirect to="/404" />} />
			</Switch>
		</SidebarWrapper>
	);
};

export default AgencyProfessionalsCreate;
